export type LockerverseSelectOption = {
  label: string;
  value: string;
};

export function LockerverseSelect({
  ariaDescribedBy,
  ariaLabel,
  ariaLabelledBy,
  className,
  id,
  invalid = false,
  name,
  onValueChange,
  options,
  value,
}: {
  ariaDescribedBy?: string;
  ariaLabel?: string;
  ariaLabelledBy?: string;
  className?: string;
  id?: string;
  invalid?: boolean;
  name: string;
  onValueChange: (value: string) => void;
  options: readonly LockerverseSelectOption[];
  value: string;
}) {
  return (
    <select
      aria-describedby={ariaDescribedBy}
      aria-invalid={invalid || undefined}
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={[
        "lockerverse-form__control",
        "lockerverse-form__select",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      id={id}
      name={name}
      onChange={(event) => onValueChange(event.currentTarget.value)}
      value={value}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
